import styled, { css } from 'styled-components'
import { GLOBAL_LOADING_Z_INDEX } from 'consts/zIndex'
import { COLORS } from 'consts/colors'

interface IGlobalLoadingWrapperProps {
  $isTransparent: boolean | undefined
}

export const GlobalLoadingWrapper = styled.div<IGlobalLoadingWrapperProps>`
  height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: ${COLORS.white};

  ${({ $isTransparent }) => {
    if ($isTransparent) {
      return css`
        position: absolute;
        top: 0;
        left: 0;
        bottom: 0;
        right: 0;
        z-index: ${GLOBAL_LOADING_Z_INDEX};
        opacity: 0.8;
      `
    }
    return ''
  }}
`
